const errorParams = {
  accountTerminated: 'ErrAccountTerminated',
  tooManyDevices: 'ErrDevicesPerAccountLimitExceeded',
  depreactedEmailVerify: 'DEPRECATED_EMAIL_VERIFY',
} as const;

export { errorParams };
